<!--
 * @Author: cgh
 * @Date: 2022-07-20
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:00:32
 * @Description: 维保合同list
-->
<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div
      v-if="operationShow && !headerShow"
      class="dev-c-tab--header_button"
    >
      <k-button
        btn-text="新增"
        :auth-type="true"
        type="success"
        icon="kestrel-icon ki-plus"
        @click="handleDialog('add')"
      />
    </div>

    <!-- 页面头部 Start -->
    <div
      v-if="headerShow"
      class="l-page__header c-page__header"
    >
      <!-- 页面标题 -->
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        维保合同管理
      </h2>

      <!-- 标题栏按钮区域 Start -->
      <div
        class="c-page__header-btns"
      >
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="refreshSearch()"
        >
          查询
        </k-button>
        <k-button
          btn-text="导出"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="resetForm()"
        >
          重置
        </k-button>
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="success"
          icon="kestrel-icon ki-plus"
          @click="handleDialog('add')"
        >
          新增
        </k-button>
        <k-button
          btn-text="导出"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-export"
          plain
          :disabled="page.rows.length<1"
          @click="handleExport()"
        >
          导出
        </k-button>
      </div>
      <!-- 标题栏按钮区域 End -->
    </div>
    <!-- 页面头部 End -->

    <!-- 查询条件 Start -->
    <div
      v-if="headerShow"
      class="l-page__item l-page--search__item"
    >
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <!-- 查询条件表单 Start -->
        <!-- tips：c-condition__form类用于查询类布局的查询条件模块使用 -->
        <el-form
          ref="filterParams"
          class="c-form c-condition__form"
          :model="filterParams"
          :inline="true"
          label-position="right"
          label-width="80px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="合同名称"
                prop="htmc"
              >
                <el-input
                  v-model.trim="filterParams.htmc"
                  class="c-form__input"
                  placeholder="合同名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="客户名称"
                prop="khmc"
              >
                <el-input
                  v-model.trim="filterParams.khmc"
                  class="c-form__input"
                  placeholder="客户名称"
                  clearable
                  maxlength="100"
                />
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="合同状态"
                prop="htzt"
              >
                <el-radio-group v-model="filterParams.htzt">
                  <el-radio label="Y">
                    有效
                  </el-radio>
                  <el-radio label="N">
                    过期
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 查询条件表单 End -->
      </hm-page-card>
    </div>
    <!-- 查询条件 End -->

    <!-- 页面主内容：查询列表 Start -->
    <div
      v-if="headerShow"
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane
          label="查询结果"
        >
          <!-- table的ref的命名根据业务名称修改 -->
          <k-table
            ref="wbhtTable"
            height="100%"
            :table-column="tableColumn"
            :data="page.rows"
            :pagination="page"
            :pagination-show="paginationShow"
            @current-change="search"
            @size-change="handleSizeChange"
          >
            <template
              #khmc="scope"
            >
              <el-link
                type="primary"
                @click="handleDialog('contract', {id:scope.row.id})"
              >
                {{ scope.row.khmc }}
              </el-link>
            </template>
            <template
              #yxq="scope"
            >
              {{ scope.row.yxqq | date("yyyy-MM-dd ") }}  至 {{ scope.row.yxqz | date("yyyy-MM-dd ") }}
            </template>
            <template
              #htzt="scope"
            >
              <el-tag
                v-if="scope.row.htzt ==='Y' "
                type="success"
              >
                有效
              </el-tag>
              <el-tag
                v-else
                type="danger"
              >
                过期
              </el-tag>
            </template>
            <el-table-column
              prop="enabled"
              label="操作"
              width="150"
              align="center"
              fixed="right"
            >
              <template
                slot-scope="scope"
              >
                <k-button
                  btn-text="编辑"
                  :auth-type="true"
                  type="primary"
                  plain
                  @click="handleDialog('edit', {id:scope.row.id})"
                />
                <k-button
                  btn-text="续签"
                  :auth-type="true"
                  type="success"
                  @click="handleDialog('xq', {id:scope.row.id})"
                />
                <k-button
                  btn-text="删除"
                  :auth-type="true"
                  type="danger"
                  @click="handleDel(scope.row, scope.$index)"
                />
              </template>
            </el-table-column>
          </k-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 页面主内容：查询列表 End -->

    <div
      v-if="!headerShow"
      class="c-page__pTable"
    >
      <k-table
        ref="wbhtTable"
        height="100%"
        :table-column="tableColumn"
        :data="page.rows"
        :pagination="page"
        :pagination-show="paginationShow"
        @current-change="search"
        @size-change="handleSizeChange"
      >
        <template
          #khmc="scope"
        >
          <el-link
            type="primary"
            @click="handleEdit(scope.row, 'contract')"
          >
            {{ scope.row.khmc }}
          </el-link>
        </template>
        <template
          #yxq="scope"
        >
          {{ scope.row.yxqq | date("yyyy-MM-dd ") }}  至 {{ scope.row.yxqz | date("yyyy-MM-dd ") }}
        </template>
        <template
          #htzt="scope"
        >
          <el-tag
            v-if="scope.row.htzt ==='Y' "
            type="success"
          >
            有效
          </el-tag>
          <el-tag
            v-else
            type="danger"
          >
            过期
          </el-tag>
        </template>
        <el-table-column
          v-if="operationShow"
          prop="enabled"
          label="操作"
          width="120"
          align="center"
          fixed="right"
        >
          <template
            slot-scope="scope"
          >
            <k-button
              btn-text="编辑"
              :auth-type="true"
              type="primary"
              plain
              @click="handleEdit(scope.row, 'edit')"
            />
            <k-button
              btn-text="删除"
              :auth-type="true"
              type="danger"
              @click="handleDel(scope.row, scope.$index)"
            />
          </template>
        </el-table-column>
      </k-table>
    </div>

    <!-- 新增 -->
    <add-dialog
      v-if="showDialogName==='add'"
      @closeDialog="handleDialog"
      @callback="search()"
    />
    <!-- 新增维保合同 -->
    <edit-dialog
      v-if="showDialogName==='edit'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
    <!-- 续签 -->
    <xq-dialog
      v-if="showDialogName==='xq'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
    <!-- 查看合同 -->
    <contract-dialog
      v-if="showDialogName==='contract'"
      :dl-params="dialogParams"
      @closeDialog="handleDialog"
      @callback="refreshSearch()"
    />
  </div>
</template>

<script>
import { wbhtManageService } from './wbht.service.js';
export default {
  name: 'Wbht',
  components: {
    editDialog: () => import('./editDialog'),
    addDialog: () => import('./addDialog'),
    xqDialog: () => import('./xqDialog'),
    contractDialog: () => import('./contractDialog')
  },
  props: {
    paginationShow: {
      type: Boolean,
      default: true
    },
    headerShow: {
      type: Boolean,
      default: true
    },
    operationShow: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false, // 页面是否loading状态

      /* 查询条件（页面绑定的查询条件） start */
      filterParams: {
        htmc: null, // 关键字
        khmc: null,
        htzt: null
      },
      /* 查询条件 end */

      /* 表单校验规则 Start */
      // filterParamsRules: {
      //   zxsjQZ: [this.$HMValidator.dateRange('开始时间')]
      // },
      /* 表单校验规则 End */

      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 导出实际查询条件（避免查询条件的双向绑定导致点击导出按钮，获取到的数据与查询结果不一致） Start */
      exportFilterParams: {},
      /* 导出实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      },

      /* 弹窗 start */
      showDialogName: '',
      dialogParams: {},
      /* 弹窗 end */
      /* 查询结果 End */

      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'khmc', slotName: 'khmc', label: '客户名称', align: 'left', minWidth: '120', type: 'text' },
        { key: 'htmc', label: '合同名称', align: 'left', minWidth: '180', type: 'text' },
        { key: 'yxq', slotName: 'yxq', label: '有效期', align: 'center', minWidth: '220', type: 'text' },
        { key: 'htzt', slotName: 'htzt', label: '合同状态', align: 'center', width: '130', type: 'text' },
        { key: 'lrdw', label: '录入单位', align: 'left', width: '130', type: 'text' },
        { key: 'createTime', label: '创建时间', align: 'center', width: '130', type: 'dateTime' }
      ]
      /* 表格列配置End */
    };
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      // [this.trueFilterParams.zxsjq, this.trueFilterParams.zxsjz] = this.trueFilterParams.zxsjQZ;
      this.search();
    },
    /**
     * @description: 查询列表方法
     * @param {number} _pageNo
     * @return {*}
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      wbhtManageService.query(this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
          // 导出条件更新为查询使用的条件
          this.exportFilterParams = JSON.parse(JSON.stringify(this.trueFilterParams));
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */

    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
       * @description: 跳转到修改界面
       * @author: cgh
       */
    handleDialog (_name, _params) {
      this.showDialogName = _name;
      this.dialogParams = _params;
    },
    /**
     * @description: 删除
     * @return {*}
     */
    handleDel (_row) {
      const _this = this;
      _this.$confirm('是否确认删除此条维保合同任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.loading = true;
        wbhtManageService.delete(_row.id)
          .then(rsp => {
            _this.$alert('删除成功！', '提示', {
              confirmButtonText: '确定',
              type: 'success',
              callback: action => {
              }
            });
            _this.search();
          })
          .catch(err => {
            console.error('删除失败！', err);
          })
          .finally(() => {
            _this.loading = false;
          });
      }).catch(() => {
      });
    },
    /**
     * @description: 导出业务流程
     * @param {*}
     * @return {*}
     */
    handleExport () {
      this.loading = true;
      wbhtManageService.export(this.exportFilterParams)
        .then(rsp => {
          const fileStream = rsp.data;
          const fileName = decodeURIComponent(escape(rsp.headers['content-disposition'].split('=')[1]));
          this.$HMUtil.downloadStreamFile(fileStream, fileName);
        })
        .catch(err => {
          console.error('导出错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created () {
    this.refreshSearch();
  },
  activated () {
    if (this.$route.params.isRefresh) {
      this.refreshSearch();
    }
  }
};
</script>
